import { render, staticRenderFns } from "./FormulaMixRaw.vue?vue&type=template&id=27f48934&scoped=true"
import script from "./FormulaMixRaw.vue?vue&type=script&lang=js"
export * from "./FormulaMixRaw.vue?vue&type=script&lang=js"
import style0 from "./FormulaMixRaw.vue?vue&type=style&index=0&id=27f48934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f48934",
  null
  
)

export default component.exports